import React, {useEffect, useState} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAuth} from './AuthContext';
import axios from './axiosConfig'; // 确保已经导入axios

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({children}) => {
    const location = useLocation();
    const {isLoggedIn} = useAuth(); // 假设 useAuth 钩子提供了isLoggedIn状态
    const [isValidToken, setIsValidToken] = useState(isLoggedIn); // 初始化isValidToken状态
    const [isLoading, setIsLoading] = useState(true); // 添加一个isLoading状态来处理加载逻辑

    useEffect(() => {
        const verifyToken = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                setIsValidToken(false);
                setIsLoading(false);
                return;
            }

            try {
                // 假设有一个API端点来验证令牌
                const response = await axios.get('/api/verifyToken');
                if (response.status === 200) {
                    setIsValidToken(true);
                } else {
                    throw new Error('Token validation failed');
                }
            } catch (error) {
                console.error('Token verification failed:', error);
                localStorage.removeItem('token');  // 令牌无效时移除令牌
                setIsValidToken(false);
            }
            setIsLoading(false);
        };

        if (!isLoggedIn) {
            verifyToken();
        } else {
            setIsValidToken(true);
            setIsLoading(false);
        }
    }, [isLoggedIn]);

    if (isLoading) {
        return <div>Loading...</div>; // 显示加载状态
    }

    if (!isValidToken) {
        console.log('ProtectedRoute - not logged in, redirecting to /login');
        return <Navigate to="/login" state={{from: location}} replace/>;
    }

    console.log('ProtectedRoute - logged in, rendering children');
    return <>{children}</>;
};

export default ProtectedRoute;
